export const STYLE_SCHEMA = {
  backgroundColor: {
    label: 'Background',
    type: 'color',
  },
  color: {
    label: 'Text Color',
    type: 'color',
    onlyFor: ['text'],
  },
  fontSize: {
    label: 'Font Size',
    type: 'number',
    min: 8,
    max: 120,
    onlyFor: ['text'],
  },
  fontWeight: {
    label: 'Font Weight',
    type: 'select',
    options: [
      { label: 'Light', value: 300 },
      { label: 'Regular', value: 400 },
      { label: 'Medium', value: 500 },
      { label: 'Bold', value: 700 },
    ],
    onlyFor: ['text'],
  },
  textAlign: {
    label: 'Text Align',
    type: 'select',
    options: [
      { label: 'Left', value: 'left' },
      { label: 'Center', value: 'center' },
      { label: 'Right', value: 'right' },
    ],
    onlyFor: ['text'],
  },
  objectFit: {
    label: 'Object Fit',
    type: 'select',
    options: ['contain', 'cover', 'fill'],
    onlyFor: ['image'],
  },
  borderRadius: {
    label: 'Border Radius',
    type: 'number',
    min: 0,
    max: 100,
  },
  borderColor:{
    label:'Border Color',
    type: 'color',
    onlyFor: ['image','text'],
  },
  borderWidth: {
    label: 'Border Width',
    type: 'number',
    min: 0,
    max: 20,
  },
};
